import { InputRow } from "../../components/Rows"
import { useTranslation } from "react-i18next";


const ManufacturerForm = ({ manufacturer, handleInputChange, invalidFields }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-4">
              <InputRow
                  label={t("common.name")}
                  value={manufacturer?.manufacturerName || ""}
                  onChange={(value) => handleInputChange("manufacturerName", value)}
                  invalid={invalidFields?.includes("manufacturerName")}
              />

      </div>
    </>
  );
};

export default ManufacturerForm;
